<template>
	<v-row>
		<v-col cols="12" class="pt-0" v-if="report !== null">
<!--			<div class="subtitle-1 report-title" v-html="report.title"></div>-->
			<v-simple-table>
				<template v-slot:default>
					<thead>
					<tr>
						<th v-for="(field, key) in tableData.headers" :class="{'text-right' : field.align == 'right'}"
							:key="key">
							{{ field.name }}
						</th>
					</tr>
					</thead>
					<tbody>
					<tr v-for="(row, rowKey) in tableData.items" :key="rowKey">
						<td :class="{'text-right' : tableData.headers[itemKey].align == 'right'}"
							v-for="(item, itemKey) in row" :key="itemKey">
							{{ item }}
						</td>
					</tr>
					</tbody>
				</template>
			</v-simple-table>
		</v-col>
	</v-row>
</template>

<script>
export default {
	name: "Report",
	props: ["report"],
	data() {
		return {}
	},
	computed: {
		tableData() {
			let data = {
				headers: [],
				items: []
			}
			if (this.report.type == 'S') {
				data.headers = [
					{
						name: 'Početno stanje',
						align: 'left'
					},
					{
						name: 'Datum početnog stanja',
						align: 'left'
					},
					{
						name: 'Prihodi',
						align: 'right'
					},
					{
						name: 'Troškovi',
						align: 'right'
					},
					{
						name: "Stanje računa",
						align: 'right'
					},
					{
						name: "Dospjelo",
						align: 'right'
					},
					{
						name: "Nedospjelo",
						align: 'right'
					}
				];
				data.items = [
					[
						this.report.data['POČETNO STANJE_display'],
						this.report.data['DATUM PS_display'],
						this.report.data['PRIHODI_display'],
						this.report.data['TROŠKOVI_display'],
						this.report.data['STANJE RAČUNA_display'],
						this.report.data['DOSPJELO_display'],
						this.report.data['NEDOSPJELO_display']
					]
				]
			}
			if (this.report.type == 'R') {
				data.headers = [
					{
						name: 'Vrsta posla',
						align: 'left'
					},
					{
						name: 'Prihod',
						align: 'right'
					},
					{
						name: 'Trošak',
						align: 'right'
					}
				];
				data.items = [];
				for (let item of this.report.data) {
					data.items.push([
						item['VRSTA POSLA'],
						item['PRIHOD_display'],
						item['TROŠAK_display']
					]);
				}
			}
			if (this.report.type == 'B') {
				data.headers = [
					{
						name: 'Ulaz',
						align: 'left'
					},
					{
						name: 'Obveznik',
						align: 'left'
					},
					{
						name: 'Zaduženje',
						align: 'right'
					},
					{
						name: 'Plaćeno',
						align: 'right'
					},
					{
						name: 'Saldo',
						align: 'right'
					}
				];
				data.items = [];
				for (let item of this.report.data) {
					data.items.push([
						item['ULAZ'],
						item['OBVEZNIK'],
						item['ZADUŽENJE_display'],
						item['PLAĆENO_display'],
						item['SALDO_display']
					]);
				}
			}
			if (this.report.type == 'D') {
				data.headers = [
					{
						name: 'Ulaz',
						align: 'left'
					},
					{
						name: 'Obveznik',
						align: 'left'
					},
					{
						name: 'Prostor',
						align: 'left'
					},
					{
						name: 'Dugovanje',
						align: 'right'
					}
				];
				data.items = [];
				for (let item of this.report.data) {
					data.items.push([
						item['ULAZ'],
						item['OBVEZNIK'],
						item['PROSTOR'],
						item['DUGOVANJE_display']
					]);
				}
			}

			return data;
		}
	},
	methods: {},
	mounted() {

	}
}
</script>
